
import { useGetAllItemGroupsQuery } from "Services/Admin";
import { ProductAdminRequestDTO } from "Interface";
import { PLANT } from "Constants";
import { ChangeEvent, Dispatch, FC, SetStateAction, useMemo } from "react";
import Select from "react-select";

interface ItemGroupSectionProps {
    formData: ProductAdminRequestDTO;
    setFormData: Dispatch<SetStateAction<ProductAdminRequestDTO>>;
    mode: "add" | "edit" | "view";
    open: boolean;
    toggleSection: () => void;
}

export const ItemGroupSection: FC<ItemGroupSectionProps> = ({
    formData,
    setFormData,
    mode,
    open,
    toggleSection,
}) => {
    const { data, isLoading, isError } = useGetAllItemGroupsQuery(PLANT);
    const itemGroupOptions = useMemo(() => {
        const safeItemGroups = data ?? [];
        return safeItemGroups.map((group) => ({
            value: group.itemGroupName,
            label: group.itemGroupName
        }));
    }, [data]);

    const selectedOption = itemGroupOptions.find(
        option => option.value === formData.itemGroupId
    ) || null;

    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value ? Number(value) : undefined
        }));
    };

    return (
        <div className="font-body tracking-wider border rounded-md">
            <button
                type="button"
                onClick={toggleSection}
                className="w-full px-4 py-3 text-left flex justify-between items-center hover:bg-gray-50"
            >
                <h3 className="text-lg font-medium">Product Group</h3>
                {open ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-up h-5 w-5"><path d="m18 15-6-6-6 6" /></svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down h-5 w-5"><path d="m6 9 6 6 6-6" /></svg>
                )}
            </button>
            {open && (
                <div className="px-4 pb-4">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-500 mb-1">
                                Select Related Product
                            </label>
                            <Select
                                name="itemGroupId"
                                value={selectedOption}
                                onChange={(selectedOption) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        itemGroupId: selectedOption?.value || undefined
                                    }));
                                }}
                                options={itemGroupOptions}
                                isDisabled={mode === "view" || isLoading}
                                placeholder="Search and Select Related Product"
                                className="text-sm"
                                classNamePrefix="select"
                                isSearchable
                                isClearable
                                 menuPortalTarget={document.body}
                                 menuPosition="fixed"
                                styles={{
                                 menuPortal: base => ({ ...base, zIndex: 9999 }),
                                 menu: base => ({
                                 ...base,
                                 maxHeight: "200px",
                                 overflowY: "auto"
                        })
                    }}
                            />

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};